import { Layout, SchemaBreadcrumb, SEOHead } from "@/components";
import {
	CoursesList,
	CursosFeatureSection,
	CursosHero,
} from "@/components/cursos";
import { useCourses } from "@/hooks/use-courses";

const Cursos = () => {
	const { courses, isLoading } = useCourses();

	return (
		<Layout>
			<SEOHead
				title="Cursos para o Mercado Imobiliário | Capacitação Profissional"
				description="Cursos especializados para corretores, cartórios e profissionais do mercado imobiliário. Conteúdo prático e atualizado sobre CIB e regulamentações."
				canonicalUrl="/cursos"
				keywords="cursos mercado imobiliário, capacitação imobiliária, curso corretor de imóveis, treinamento para cartórios, curso CIB, investimento imobiliário"
			/>
			<SchemaBreadcrumb />

			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
				<CursosHero />

				<section className="mb-16">
					<CoursesList courses={courses} isLoading={isLoading} />
				</section>

				<CursosFeatureSection />
			</div>
		</Layout>
	);
};

export default Cursos;
